import React from "react";
import { FaAward } from "react-icons/fa"; // Award icon
import { GiDiamondTrophy } from "react-icons/gi"; // Diamond icon
import { FaFlask } from "react-icons/fa";
import { AiOutlineAppstoreAdd } from "react-icons/ai"; // Alternative certificate icon
import NaturalDiamond from "../../assets/natural.jpeg";
import "./DiamondSection.css";

export default function DiamondSection() {
  return (
    <div>
      {/* Section Header */}
      <section className="diamond1-header">
        <div className="diamond1-container">
          <h2 className="diamond1-heading">Our Diamond Collection</h2>
          <p className="diamond1-description">
            Discover the beauty and brilliance of both natural and lab-grown
            diamonds. Whether you're seeking timeless elegance or an
            eco-conscious choice, we offer the finest quality diamonds for every
            preference.
          </p>
        </div>
      </section>

      {/* Natural Diamonds Section */}
      <section id="natural" className="diamond1-section">
        <div className="diamond1-container">
          <div className="diamond1-grid fade-up1">
            <div>
              <h3 className="diamond1-subheading">Natural Diamonds</h3>
              <p className="diamond1-text">
                Our collection of natural diamonds represents nature's finest
                creations, carefully selected and crafted to perfection. Each
                stone tells a unique story formed over millions of years.
              </p>
              <ul className="diamond1-list">
                <li className="diamond1-list-item">
                  <GiDiamondTrophy className="diamond1-icon" />
                  <span>Ethically sourced diamonds</span>
                </li>
                <li className="diamond1-list-item">
                  <AiOutlineAppstoreAdd className="diamond1-icon" />
                  <span>GIA & IGI certified</span>
                </li>
                <li className="diamond1-list-item">
                  <FaAward className="diamond1-icon" />
                  <span>Premium quality guarantee</span>
                </li>
              </ul>
            </div>
            <div className="image-container12">
              <img
                src={NaturalDiamond}
                alt="Natural diamond"
                className="diamond1-image"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Lab Grown Diamonds Section */}
      <section id="lab-grown" className="diamond1-section-lab">
        <div className="diamond1-container">
          <div className="diamond1-grid fade-up1">
            <div className="labgrown-text">
              <h3 className="diamond1-subheading">Lab Grown Diamonds</h3>
              <p className="diamond1-text">
                Our lab-grown diamonds offer the same brilliance and quality as
                natural diamonds, created using cutting-edge technology. Perfect
                for the environmentally conscious consumer.
              </p>
              <ul className="diamond1-list">
                <li className="diamond1-list-item">
                  <FaFlask className="diamond1-icon" />
                  <span>Advanced technology</span>
                </li>
                <li className="diamond1-list-item">
                  <AiOutlineAppstoreAdd className="diamond1-icon" />
                  <span>IGI certified</span>
                </li>
                <li className="diamond1-list-item">
                  <FaAward className="diamond1-icon" />
                  <span>Eco-friendly choice</span>
                </li>
              </ul>
            </div>
            <div className="image-container12">
              <img
                src="https://images.unsplash.com/photo-1599707367072-cd6ada2bc375?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80"
                alt="Lab grown diamond"
                className="diamond1-image"
              />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
